// Mirrors FamilyFestFaqTypeEnum in Happiness.Backend: which FamilyFest page a FAQ category is for.
// A category without a type (created before this existed) counts as Registration.
export var FamilyFestFaqTypeEnum;
(function (FamilyFestFaqTypeEnum) {
    FamilyFestFaqTypeEnum[FamilyFestFaqTypeEnum["Registration"] = 1] = "Registration";
    FamilyFestFaqTypeEnum[FamilyFestFaqTypeEnum["EventPage"] = 2] = "EventPage";
})(FamilyFestFaqTypeEnum || (FamilyFestFaqTypeEnum = {}));
export const FamilyFestFaqTypeEnumDisplay = {
    [FamilyFestFaqTypeEnum.Registration]: 'events.eventDetails.faqTab.faqType.registration',
    [FamilyFestFaqTypeEnum.EventPage]: 'events.eventDetails.faqTab.faqType.eventPage'
};
export const faqTypeOfCategory = (category) => category.familyFestFaqType ?? FamilyFestFaqTypeEnum.Registration;
